import { Model } from "@vuex-orm/core";

export interface tagEntity {
  tagId: number;
  tagName: string;
  description: string | null;
  isPinned: boolean;
  isGlobal: boolean;
}

export class tagEntity extends Model {
  static entity = "tagEntity";
  static primaryKey = "tagId";
  static fields() {
    return {
      tagId: this.number(0),
      tagName: this.string(""),
      description: this.attr(null),
      isPinned: this.boolean(false),
      isGlobal: this.boolean(false),
    };
  }

  get tagNameForSort(): string {
    return this.tagName.toLowerCase();
  }
}
